module.exports = __webpack_public_path__ + "img/s23.a3d3359.png";